import clsx from 'clsx';
import { colors } from '@ovpn-ui/styles';
import maybeDataTestId from '../_internal/utils/maybeDataTestId';
import { StyledSpinner } from './Spinner.styles';
import { jsx as _jsx } from "react/jsx-runtime";
function Spinner({
  size = 20,
  color = colors.neutralTextBody,
  'data-testid': dataTestId,
  className,
  style
}) {
  return /*#__PURE__*/_jsx(StyledSpinner, {
    className: clsx('ovpn-spinner', className),
    style: style,
    $size: size,
    $color: color,
    ...maybeDataTestId(dataTestId)
  });
}
export default Spinner;